import { connect } from "react-redux";
import {
  anonymousUser,
  registeredUser,
} from "../../utils/helpers/IAmVioletHelper";
import ActionsMenu from "../actionsMenu/ActionsMenu";
import "./HeaderFirstVersion.css";
import logo from "../../assets/images/logo.svg";
import { useResize } from "../../modules/Geral/hooks/useResize";
import { fetchUserWithAllAttributes, saveLanguage } from "../../store/actions";

/**
 * Functional Component: HeaderFirstVersion
 * The header for violet, is present on every page and contains links to meet violet, login, sign up, my profile and analytics
 *
 * @param {Object} currentUser
 * @param {Object} preliminaryResult
 * @param {Object} answerValues
 * @param {Boolean} onProfile
 * @param {Boolean} meetViolet
 * @param {Boolean} myAnalytics
 * @param {Boolean} survey
 * @param {Object} queryParams
 * @returns {Element}
 * */
const HeaderFirstVersion = ({
  currentUser,
  preliminaryResult,
  answerValues,
  survey,
  language,
}) => {
  const [innerWidth] = useResize();

  const renderSignupButton = () => {
    return (
      <div
        id="Sign-up-button-container"
        className="right-side-header Main-Button-Fill-Avenir-Desktop-signup"
        style={{
          backgroundColor: "#76768012",
          color: "white",
          cursor: "not-allowed",
        }}
        onClick={() => {}}
      >
        {" "}
        <span className="right-side-header" id="Sign-up-button">
          Sign up
        </span>
      </div>
    );
  };

  const renderMeetVioletButton = () =>
    renderButton({
      className: "Meet-violet",
      onClick: () => {},
      children: "Meet violet",
      id: "meet-violet",
      customStyles: { width: "6vw" },
      selected: undefined,
    });

  const renderMyAnalyticsButton = () =>
    renderButton({
      className: "Login",
      onClick: () => {},
      children: <span>Login</span>,
      selected: undefined,
      customStyles: { width: "6.5vw" },
    });

  const renderButton = ({
    children,
    id,
    className = "",
    onClick,
    selected,
    customStyles = {},
  }) => {
    return (
      <span
        className={`right-side-header header-button ${className} d-flex flex-column align-items-center`}
        style={{ color: "#76768012", cursor: "not-allowed" }}
        onClick={() => {}}
      >
        {children}
        {selected ? (
          <div
            id={`${id}-selector`}
            className="purple-page-selector"
            style={{ ...customStyles }}
          />
        ) : null}
      </span>
    );
  };

  const renderOptions = () => {
    return (
      <div className="collapse navbar-collapse" id="navbar">
        <div className="navbar-nav mt-3 mt-md-0 justify-content-lg-end w-100 align-items-center">
          {renderMeetVioletButton()}
          {renderMyAnalyticsButton()}
        </div>

        {renderSignupButton()}
      </div>
    );
  };

  return (
    <>
      {innerWidth < 992 ? (
        <div className="header">
          <nav className="top-rectangle" />
        </div>
      ) : null}
      <header
        style={
          innerWidth < 992
            ? { position: "fixed", width: "100%", zIndex: "6", top: "0" }
            : {}
        }
        className="header"
      >
        <nav className="navbar navbar-expand-md navbar-light shadow top-rectangle ">
          <div className="container-fluid">
            <img
              onClick={
                survey
                  ? null
                  : () => {
                      if (!currentUser) {
                        anonymousUser({ preliminaryResult, answerValues });
                      } else {
                        registeredUser({ currentUser });
                      }
                    }
              }
              src={logo}
              alt="logo"
              className="logo"
              style={{ cursor: survey ? null : "pointer" }}
            />

            {window.innerWidth < 992 ? <ActionsMenu /> : renderOptions()}
          </div>
        </nav>
      </header>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
    preliminaryResult: state.preliminaryResult,
    answerValues: state.answerValues,
    queryParams: state.queryParams,
    language: state.language,
  };
};

export default connect(mapStateToProps, {
  saveLanguage: saveLanguage,
  fetchUserWithAllAttributes,
})(HeaderFirstVersion);
